import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { Input } from '@cian/ui-kit/input';
import IMask from 'imask';
import * as React from 'react';
import { MASK_PROPS, OWN_PROPS } from './constants';
export var MaskedInput = /*#__PURE__*/function (_React$Component) {
  _inherits(MaskedInput, _React$Component);
  var _super = _createSuper(MaskedInput);
  function MaskedInput() {
    var _this;
    _classCallCheck(this, MaskedInput);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "maskRef", void 0);
    _defineProperty(_assertThisInitialized(_this), "handleAccept", function () {
      if (_this.props.onAccept) {
        _this.props.onAccept(_this.maskValue);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleComplete", function () {
      if (_this.props.onComplete) {
        _this.props.onComplete(_this.maskValue);
      }
    });
    return _this;
  }
  _createClass(MaskedInput, [{
    key: "maskValue",
    get: function get() {
      if (!this.maskRef) {
        return '';
      }
      return this.maskRef.unmaskedValue;
    },
    set: function set(value) {
      if (!this.maskRef) {
        return;
      }
      this.maskRef.unmaskedValue = value;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.props.mask) {
        return;
      }
      this.initMask();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var value = this.props.value;
      var maskOptions = this.getMaskOptionsFromProps();
      if (maskOptions.mask) {
        if (this.maskRef) {
          this.maskRef.updateOptions(maskOptions);
          if (typeof value !== 'undefined' && (value !== this.maskValue || typeof value !== 'string' && this.maskRef.value === '') && !this.maskRef.el.isActive) {
            this.maskValue = value;
          }
        } else {
          this.initMask(maskOptions);
          if (value !== this.maskValue) {
            this.handleAccept();
          }
        }
      } else {
        this.destroyMask();

        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion, @typescript-eslint/no-explicit-any
        this.props.inputRef.current.value = value;
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.destroyMask();
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(Input, _extends({
        inputRef: this.props.inputRef
      }, this.getNonMaskProps(), {
        defaultValue: this.props.value
      }));
    }
  }, {
    key: "initMask",
    value: function initMask() {
      var maskOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getMaskOptionsFromProps();
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      this.maskRef = IMask(this.props.inputRef.current, maskOptions).on('accept', this.handleAccept).on('complete', this.handleComplete);
      this.maskValue = this.props.value || '';
    }
  }, {
    key: "destroyMask",
    value: function destroyMask() {
      if (this.maskRef) {
        this.maskRef.destroy();
        delete this.maskRef;
      }
    }
  }, {
    key: "getMaskOptionsFromProps",
    value: function getMaskOptionsFromProps() {
      var _this2 = this;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      var availableOptions = Object.keys(this.props).filter(function (key) {
        return MASK_PROPS.includes(key);
      });
      return availableOptions.reduce(function (accumulator, currentValue) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        accumulator[currentValue] = _this2.props[currentValue];
        return accumulator;
      }, {});
    }
  }, {
    key: "getNonMaskProps",
    value: function getNonMaskProps() {
      var _this3 = this;
      var availableOptions = Object.keys(this.props).filter(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      function (key) {
        return ![].concat(_toConsumableArray(MASK_PROPS), _toConsumableArray(OWN_PROPS)).includes(key);
      });
      return availableOptions.reduce(function (accumulator, currentValue) {
        accumulator[currentValue] = _this3.props[currentValue];
        return accumulator;
      }, {});
    }
  }]);
  return MaskedInput;
}(React.Component);
_defineProperty(MaskedInput, "defaultProps", {
  inputRef: /*#__PURE__*/React.createRef()
});